// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2817":"9f00ce81f6b84261","8105":"007ebae4a63eba26"}[chunkId] + ".css";
};